import {APIEvents} from "../constants/AnalyticsEventKeys";
import {MobileAnalyticsHelper} from "@amzn/dolphin-web-framework";
import {getNPSWClient} from "./base/ClientInterface";

export function getExceptionShipmentSummary(data, dispatcher, errorAction) {
    let startTime = Date.now();
    getNPSWClient().getExceptionShipmentSummary(data)
        .then(({success, data}) => {
            if (success) {
                dispatcher(data);
                MobileAnalyticsHelper.executeAPIAnalytics(APIEvents.ExceptionShipmentSummary, startTime);
            } else {
                errorAction("internal_error");
                MobileAnalyticsHelper.executeAPIAnalytics(APIEvents.ExceptionShipmentSummary, startTime, true);
            }
        });
}